import React from "react";

const PhoneInput = ({ value, onChange, disabled = false, ...props }) => {
    const handlePhoneChange = (e) => {
        let input = e.target.value.replace(/\D/g, '');

        if (input.startsWith('8')) {
            input = '7' + input.slice(1);
        }

        if (input.startsWith('9')) {
            input = '7' + input;
        }

        input = input.slice(0, 11);
        const formattedPhone = '+7' + input.slice(1);

        onChange(formattedPhone);
    };

    return (
        <input
            type="tel"
            disabled={disabled}
            className="input"
            placeholder="Номер телефона"
            value={value}
            onChange={handlePhoneChange}
            {...props}
        />
    );
};

export default PhoneInput;
